module.exports = "<div class=\"autocomplete-container\" id=\"autocomplete\" ng-init=\"$ctrl.initAutocomplete()\"></div>";